import { apiClient } from '@/lib/api-client';
import { API_ROUTES } from '@/lib/api-config';
import type { Content } from '@/types/content.types';

/**
 * Get all content (main site content with relations)
 */
export const getContent = async (): Promise<Content> => {
  return apiClient.get<Content>(API_ROUTES.CONTENT);
};

/**
 * Get content by specific key
 */
export const getContentByKey = async (key: string): Promise<Content> => {
  return apiClient.get<Content>(API_ROUTES.CONTENT_BY_KEY(key));
};
